// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing page */
.choose_lot{
    display: flex;
    justify-content: center;
    align-items: center;
}
#choose_account_holder{
    width: 80%;
}
#new_member_link{
    text-align: center !important;
    color: black;
}
#new_member_link_dark{
    text-align: center !important;
    color: #EA4335;
}
/* Guest Page */
.WelcomeHeadder{
    font-weight: 300;
    font-size: 1.4em;
    color: #585858;
    margin-top: 25px;
    margin-bottom: -30px;
}
.tc_holder{
    width: 100%;
    display: flex;
    justify-content: center;
}
.terms_condition{
    border: none;
    background: none;
    margin-top: 20px;
    border-bottom: 1px solid #585858;
    width: 50%;
}
.content_holder{
    width: 70%;
    margin-top: -16vh;
}
.content_holder .form{
    display: flex;
    flex-direction: column;
    margin-top: 30px;
}
.labels{
    color: #585858;
    margin: 15px 0px 5px 0px;
}
.labels:after{
    content: "*";
    content: red;
}
.submitBtn{
background-color: #F0F0F3;
  margin-top: 50px;
  height: 44px;
  border-radius: 60px;
  color: red ;
  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.submitBtn_dark{
      margin-top: 50px;
      height: 44px;
      border-radius: 60px;
      color: red ;
      background: #1E2834;
        border: 1px solid #EA4335;
        box-sizing: border-box;
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.6), -10px -10px 30px rgba(255, 255, 255, 0.12);
        border-radius: 60px;

    }
.licensePlateHolder{
    display: flex;
    justify-content: center;
    width: 100%;
}
.licensePlate{
    width: 100%;
    height: 135px;
    border: 1px solid red;
    border-radius: 20px;
    margin-top: 30px;
}
.threeSeparations{
    width: 100%;
    display: flex;
    justify-content: space-around;
}
.lPlateDot{
    width: 30px;
    height: 5px;
    background-color: red;
    border-radius: 10px;
    margin-top: 10px;
}
.line{
    width: 100%;
    height: 1px;
    background-color: red;
    margin-top: 10px;
}
.plateInput{
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.center{
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
    margin-top:0px;
}
.licensePlateInput{
    width: 50%;
}
/* Set Time Page */
.align_timer_btns{
    display: flex;
    justify-content: center;
}
.btns_img_container{
    margin-top: 40px;
}
.timer_holder{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
}
.stacked_container{
    display: flex;
    flex-direction: column;
   text-align: center;
}
.slim{
    font-weight: 400;
}
.stacked{
    display: flex;
    flex-direction: column;
    width: 60vw;

}
.position-center{
    display: flex;
    justify-content: center;
    width: 100vw !important;
}

/* CVV Card styles */
.card_{
    width: 90%;
    height: 200px;
    border: 1px solid black;
    border-radius: 30px;
    margin-left: 5%;

}
.card_dark{
    width: 90%;
    height: 200px;
    border: 1px solid #EA4335;
    border-radius: 30px;
    margin-left: 5%;

}
#CCnumber{
    max-width: 83%;
    margin-left: 7%;
    max-height: -moz-fit-content;
    max-height: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    /*border: 1px solid red;*/
    padding: 6px;
    border-radius: 7px;
}
#CCnumberLabel{
    margin-left: 7%;
    margin-top: 10%;
}
.auth_holder{
    display: flex;
    margin-top: 20px;
}
#expiration{
    width: 80px;
    margin-left: 0%;
    max-height: -moz-fit-content;
    max-height: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border: 1px solid red;
    padding: 7px;
    border-radius: 7px;
}
#cvc{
    width: 60px;
    margin-left: 0%;
    max-height: -moz-fit-content;
    max-height: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border: 1px solid red;
    padding: 7px;
    border-radius: 7px;
}
.stacked_{
    display: flex;
    flex-direction: column;
}
.ccIcon{
    width: 40px;
    margin-top: 20px;
}
.auth_holder{
    display: flex;
    justify-content: space-around;
}
.lock{
    width: 15px;
    height: 15px;
}
.securePayment_{
display: flex;
align-items: center;
}
.securePaymentHolder{
   width: 100%;
   display: flex;
   justify-content: center;
   margin-top: 10%;
}
.ccCardSubmissionHolder{
    width: 100%;
    display: flex;
    justify-content: center;
}
.ccCardSubmission{
    width: 60%;
}
.countdown_digits{
    width: 70%;
    display: flex;
    justify-content: space-around;
}
.countdown_digits_holder{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}


.countdown_adjustment{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    /* background-color: #F0F0F3; */
    justify-content: center;
    align-items:center;
    z-index: 10;
    background: #F9F9FC;
    border: 1px solid #848484;
    box-shadow: 2px 4px 16px rgba(0, 71, 94, 0.2), -4px -4px 16px #FFFFFF;
    /* animation: secondsCounter 1s infinite; */
}
.countdown_adjustment_orange{
    border: 1px solid #ff7b00 !important;
}
.countdown_adjustment_red{
    border: 1px solid red !important;
}
.txtRed{
    color: red !important;
}
.txtOrange{
    color: #ff7b00 !important;
}

.countdown_adjustment_dark{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    /* background-color: #F0F0F3; */
    justify-content: center;
    align-items:center;
    z-index: 10;
    background: #121921;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid #EA4335;
    color: white;
    /* animation: secondsCounter 1s infinite; */
}
.pulse_holder{
    margin-top: -40%;
    display: flex;
    display: -webkit-flex;
    width: 100%;
    position: relative;
    justify-content: center;
    align-items: center;
}
.circleAnimation{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #e9e9f3;
    z-index: 1;
    position: absolute;
    animation: secondsCounter 1s infinite;
}
.circleAnimation_dark{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #11161d;
    z-index: 1;
    margin-top: -40%;
    position: absolute;
    animation: secondsCounter 1s infinite;
}
@keyframes secondsCounter {
    from{
        width: 200px;
        height: 200px;
        opacity: 1;
    }
    to{
        width: 300px;
        height: 300px;
        opacity: 0;
    }
}
.digits{
    font-size: 1.2em;
    color: rgba(#292929, 60) !important;
}
.lot-info{
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    top: 8vh;
}
.loading_div{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0vh;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/pages.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA,eAAe;AACf;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;AACA,yBAAyB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,6EAA6E;EAC7E,wBAAwB;EACxB,qBAAqB;AACvB;AACA;MACM,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,WAAW;MACX,mBAAmB;QACjB,yBAAyB;QACzB,sBAAsB;QACtB,yFAAyF;QACzF,mBAAmB;;IAEvB;AACJ;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,4BAA4B;IAC5B,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;GACvB,kBAAkB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;;AAEf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;;AAEnB;AACA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;;AAEnB;AACA;IACI,cAAc;IACd,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,wBAAmB;IAAnB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;GACG,WAAW;GACX,aAAa;GACb,uBAAuB;GACvB,eAAe;AAClB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,qEAAqE;IACrE,2CAA2C;AAC/C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iDAAiD;IACjD,yBAAyB;IACzB,YAAY;IACZ,2CAA2C;AAC/C;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI;QACI,YAAY;QACZ,aAAa;QACb,UAAU;IACd;IACA;QACI,YAAY;QACZ,aAAa;QACb,UAAU;IACd;AACJ;AACA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":["/* Landing page */\n.choose_lot{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n#choose_account_holder{\n    width: 80%;\n}\n#new_member_link{\n    text-align: center !important;\n    color: black;\n}\n#new_member_link_dark{\n    text-align: center !important;\n    color: #EA4335;\n}\n/* Guest Page */\n.WelcomeHeadder{\n    font-weight: 300;\n    font-size: 1.4em;\n    color: #585858;\n    margin-top: 25px;\n    margin-bottom: -30px;\n}\n.tc_holder{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.terms_condition{\n    border: none;\n    background: none;\n    margin-top: 20px;\n    border-bottom: 1px solid #585858;\n    width: 50%;\n}\n.content_holder{\n    width: 70%;\n    margin-top: -16vh;\n}\n.content_holder .form{\n    display: flex;\n    flex-direction: column;\n    margin-top: 30px;\n}\n.labels{\n    color: #585858;\n    margin: 15px 0px 5px 0px;\n}\n.labels:after{\n    content: \"*\";\n    content: red;\n}\n.submitBtn{\nbackground-color: #F0F0F3;\n  margin-top: 50px;\n  height: 44px;\n  border-radius: 60px;\n  color: red ;\n  box-shadow: 10px 10px 30px rgba(174, 174, 192, 0.4), -10px -10px 30px #FFFFFF;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n.submitBtn_dark{\n      margin-top: 50px;\n      height: 44px;\n      border-radius: 60px;\n      color: red ;\n      background: #1E2834;\n        border: 1px solid #EA4335;\n        box-sizing: border-box;\n        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.6), -10px -10px 30px rgba(255, 255, 255, 0.12);\n        border-radius: 60px;\n\n    }\n.licensePlateHolder{\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n.licensePlate{\n    width: 100%;\n    height: 135px;\n    border: 1px solid red;\n    border-radius: 20px;\n    margin-top: 30px;\n}\n.threeSeparations{\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n}\n.lPlateDot{\n    width: 30px;\n    height: 5px;\n    background-color: red;\n    border-radius: 10px;\n    margin-top: 10px;\n}\n.line{\n    width: 100%;\n    height: 1px;\n    background-color: red;\n    margin-top: 10px;\n}\n.plateInput{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.center{\n    display: flex;\n    /* flex-direction: column; */\n    justify-content: center;\n    margin-top:0px;\n}\n.licensePlateInput{\n    width: 50%;\n}\n/* Set Time Page */\n.align_timer_btns{\n    display: flex;\n    justify-content: center;\n}\n.btns_img_container{\n    margin-top: 40px;\n}\n.timer_holder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 40px;\n}\n.stacked_container{\n    display: flex;\n    flex-direction: column;\n   text-align: center;\n}\n.slim{\n    font-weight: 400;\n}\n.stacked{\n    display: flex;\n    flex-direction: column;\n    width: 60vw;\n\n}\n.position-center{\n    display: flex;\n    justify-content: center;\n    width: 100vw !important;\n}\n\n/* CVV Card styles */\n.card_{\n    width: 90%;\n    height: 200px;\n    border: 1px solid black;\n    border-radius: 30px;\n    margin-left: 5%;\n\n}\n.card_dark{\n    width: 90%;\n    height: 200px;\n    border: 1px solid #EA4335;\n    border-radius: 30px;\n    margin-left: 5%;\n\n}\n#CCnumber{\n    max-width: 83%;\n    margin-left: 7%;\n    max-height: fit-content;\n    height: fit-content;\n    /*border: 1px solid red;*/\n    padding: 6px;\n    border-radius: 7px;\n}\n#CCnumberLabel{\n    margin-left: 7%;\n    margin-top: 10%;\n}\n.auth_holder{\n    display: flex;\n    margin-top: 20px;\n}\n#expiration{\n    width: 80px;\n    margin-left: 0%;\n    max-height: fit-content;\n    height: fit-content;\n    border: 1px solid red;\n    padding: 7px;\n    border-radius: 7px;\n}\n#cvc{\n    width: 60px;\n    margin-left: 0%;\n    max-height: fit-content;\n    height: fit-content;\n    border: 1px solid red;\n    padding: 7px;\n    border-radius: 7px;\n}\n.stacked_{\n    display: flex;\n    flex-direction: column;\n}\n.ccIcon{\n    width: 40px;\n    margin-top: 20px;\n}\n.auth_holder{\n    display: flex;\n    justify-content: space-around;\n}\n.lock{\n    width: 15px;\n    height: 15px;\n}\n.securePayment_{\ndisplay: flex;\nalign-items: center;\n}\n.securePaymentHolder{\n   width: 100%;\n   display: flex;\n   justify-content: center;\n   margin-top: 10%;\n}\n.ccCardSubmissionHolder{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.ccCardSubmission{\n    width: 60%;\n}\n.countdown_digits{\n    width: 70%;\n    display: flex;\n    justify-content: space-around;\n}\n.countdown_digits_holder{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n\n.countdown_adjustment{\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    /* background-color: #F0F0F3; */\n    justify-content: center;\n    align-items:center;\n    z-index: 10;\n    background: #F9F9FC;\n    border: 1px solid #848484;\n    box-shadow: 2px 4px 16px rgba(0, 71, 94, 0.2), -4px -4px 16px #FFFFFF;\n    /* animation: secondsCounter 1s infinite; */\n}\n.countdown_adjustment_orange{\n    border: 1px solid #ff7b00 !important;\n}\n.countdown_adjustment_red{\n    border: 1px solid red !important;\n}\n.txtRed{\n    color: red !important;\n}\n.txtOrange{\n    color: #ff7b00 !important;\n}\n\n.countdown_adjustment_dark{\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    /* background-color: #F0F0F3; */\n    justify-content: center;\n    align-items:center;\n    z-index: 10;\n    background: #121921;\n    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n    border: 1px solid #EA4335;\n    color: white;\n    /* animation: secondsCounter 1s infinite; */\n}\n.pulse_holder{\n    margin-top: -40%;\n    display: flex;\n    display: -webkit-flex;\n    width: 100%;\n    position: relative;\n    justify-content: center;\n    align-items: center;\n}\n.circleAnimation{\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background-color: #e9e9f3;\n    z-index: 1;\n    position: absolute;\n    animation: secondsCounter 1s infinite;\n}\n.circleAnimation_dark{\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background-color: #11161d;\n    z-index: 1;\n    margin-top: -40%;\n    position: absolute;\n    animation: secondsCounter 1s infinite;\n}\n@keyframes secondsCounter {\n    from{\n        width: 200px;\n        height: 200px;\n        opacity: 1;\n    }\n    to{\n        width: 300px;\n        height: 300px;\n        opacity: 0;\n    }\n}\n.digits{\n    font-size: 1.2em;\n    color: rgba(#292929, 60) !important;\n}\n.lot-info{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    top: 8vh;\n}\n.loading_div{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
